export const hit = async (url: string, init?: RequestInit) => {
  return await fetch(url, {
    ...init,
    headers: {
      Accept: "application/json",
      ...init?.headers,
    },
    credentials: "include", // Important: This allows auth session cookies to be sent
  });
};
